import { createSlice } from "@reduxjs/toolkit";

const powerSystemMonitoringSlice = createSlice({
  name: "powerSystemMonitoring",
  initialState: {
    enre: {
      ufs: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
    },
    cammesa: {
      generationMatrix: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      historicalRecords: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      powerFlows: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      currentDemand: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      operations: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      regions: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
      marginalCosts: {
        data: null,
        isFetching: false,
        error: null,
        activeRequestId: null,
      },
    },
    weather: {
      data: null,
      isFetching: false,
      error: null,
      activeRequestId: null,
    },
    dollar: {
      data: null,
      isFetching: false,
      error: null,
      activeRequestId: null,
    },
  },
  reducers: {
    cammesaGenerationMatrixStart: (state, action) => {
      state.cammesa.generationMatrix.isFetching = true;
      state.cammesa.generationMatrix.error = null;
      state.cammesa.generationMatrix.activeRequestId = action.payload;
    },
    cammesaGenerationMatrixSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.generationMatrix.activeRequestId !== requestId) return;

      state.cammesa.generationMatrix.data = data;
      state.cammesa.generationMatrix.isFetching = false;
      state.cammesa.generationMatrix.error = null;
      state.cammesa.generationMatrix.activeRequestId = null;
    },
    cammesaGenerationMatrixFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.generationMatrix.activeRequestId !== requestId) return;

      state.cammesa.generationMatrix.isFetching = false;
      state.cammesa.generationMatrix.error = error;
      state.cammesa.generationMatrix.activeRequestId = null;
    },
    cammesaHistoricalRecordsStart: (state, action) => {
      state.cammesa.historicalRecords.isFetching = true;
      state.cammesa.historicalRecords.error = null;
      state.cammesa.historicalRecords.activeRequestId = action.payload;
    },
    cammesaHistoricalRecordsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.historicalRecords.activeRequestId !== requestId) return;

      state.cammesa.historicalRecords.data = data;
      state.cammesa.historicalRecords.isFetching = false;
      state.cammesa.historicalRecords.error = null;
      state.cammesa.historicalRecords.activeRequestId = null;
    },
    cammesaHistoricalRecordsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.historicalRecords.activeRequestId !== requestId) return;

      state.cammesa.historicalRecords.isFetching = false;
      state.cammesa.historicalRecords.error = error;
      state.cammesa.historicalRecords.activeRequestId = null;
    },
    cammesaPowerFlowsStart: (state, action) => {
      state.cammesa.powerFlows.isFetching = true;
      state.cammesa.powerFlows.error = null;
      state.cammesa.powerFlows.activeRequestId = action.payload;
    },
    cammesaPowerFlowsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.powerFlows.activeRequestId !== requestId) return;

      state.cammesa.powerFlows.data = data;
      state.cammesa.powerFlows.isFetching = false;
      state.cammesa.powerFlows.error = null;
      state.cammesa.powerFlows.activeRequestId = null;
    },
    cammesaPowerFlowsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.powerFlows.activeRequestId !== requestId) return;

      state.cammesa.powerFlows.isFetching = false;
      state.cammesa.powerFlows.error = error;
      state.cammesa.powerFlows.activeRequestId = null;
    },
    enreUfsStart: (state, action) => {
      state.enre.ufs.isFetching = true;
      state.enre.ufs.error = null;
      state.enre.ufs.activeRequestId = action.payload;
    },
    enreUfsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.enre.ufs.activeRequestId !== requestId) return;

      state.enre.ufs.data = data;
      state.enre.ufs.isFetching = false;
      state.enre.ufs.error = null;
      state.enre.ufs.activeRequestId = null;
    },
    enreUfsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.enre.ufs.activeRequestId !== requestId) return;

      state.enre.ufs.isFetching = false;
      state.enre.ufs.error = error;
      state.enre.ufs.activeRequestId = null;
    },
    weatherHourlyStart: (state, action) => {
      state.weather.isFetching = true;
      state.weather.error = null;
      state.weather.activeRequestId = action.payload;
    },
    weatherHourlySuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.weather.activeRequestId !== requestId) return;

      state.weather.data = data;
      state.weather.isFetching = false;
      state.weather.error = null;
      state.weather.activeRequestId = null;
    },
    weatherHourlyFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.weather.activeRequestId !== requestId) return;

      state.weather.isFetching = false;
      state.weather.error = error;
      state.weather.activeRequestId = null;
    },
    dollarQuotesStart: (state, action) => {
      state.dollar.isFetching = true;
      state.dollar.error = null;
      state.dollar.activeRequestId = action.payload;
    },
    dollarQuotesSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.dollar.activeRequestId !== requestId) return;

      state.dollar.data = data;
      state.dollar.isFetching = false;
      state.dollar.error = null;
      state.dollar.activeRequestId = null;
    },
    dollarQuotesFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.dollar.activeRequestId !== requestId) return;

      state.dollar.isFetching = false;
      state.dollar.error = error;
      state.dollar.activeRequestId = null;
    },
    cammesaCurrentDemandStart: (state, action) => {
      state.cammesa.currentDemand.isFetching = true;
      state.cammesa.currentDemand.error = null;
      state.cammesa.currentDemand.activeRequestId = action.payload;
    },
    cammesaCurrentDemandSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.currentDemand.activeRequestId !== requestId) return;

      state.cammesa.currentDemand.data = data;
      state.cammesa.currentDemand.isFetching = false;
      state.cammesa.currentDemand.error = null;
      state.cammesa.currentDemand.activeRequestId = null;
    },
    cammesaCurrentDemandFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.currentDemand.activeRequestId !== requestId) return;

      state.cammesa.currentDemand.isFetching = false;
      state.cammesa.currentDemand.error = error;
      state.cammesa.currentDemand.activeRequestId = null;
    },
    cammesaOperationsStart: (state, action) => {
      state.cammesa.operations.isFetching = true;
      state.cammesa.operations.error = null;
      state.cammesa.operations.activeRequestId = action.payload;
    },
    cammesaOperationsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.operations.activeRequestId !== requestId) return;

      state.cammesa.operations.data = data;
      state.cammesa.operations.isFetching = false;
      state.cammesa.operations.error = null;
      state.cammesa.operations.activeRequestId = null;
    },
    cammesaOperationsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.operations.activeRequestId !== requestId) return;

      state.cammesa.operations.isFetching = false;
      state.cammesa.operations.error = error;
      state.cammesa.operations.activeRequestId = null;
    },
    cammesaRegionsStart: (state, action) => {
      state.cammesa.regions.isFetching = true;
      state.cammesa.regions.error = null;
      state.cammesa.regions.activeRequestId = action.payload;
    },
    cammesaRegionsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.regions.activeRequestId !== requestId) return;

      state.cammesa.regions.data = data;
      state.cammesa.regions.isFetching = false;
      state.cammesa.regions.error = null;
      state.cammesa.regions.activeRequestId = null;
    },
    cammesaRegionsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.regions.activeRequestId !== requestId) return;

      state.cammesa.regions.isFetching = false;
      state.cammesa.regions.error = error;
      state.cammesa.regions.activeRequestId = null;
    },
    cammesaMarginalCostsStart: (state, action) => {
      state.cammesa.marginalCosts.isFetching = true;
      state.cammesa.marginalCosts.error = null;
      state.cammesa.marginalCosts.activeRequestId = action.payload;
    },
    cammesaMarginalCostsSuccess: (state, action) => {
      const { requestId, data } = action.payload;
      if (state.cammesa.marginalCosts.activeRequestId !== requestId) return;

      state.cammesa.marginalCosts.data = data;
      state.cammesa.marginalCosts.isFetching = false;
      state.cammesa.marginalCosts.error = null;
      state.cammesa.marginalCosts.activeRequestId = null;
    },
    cammesaMarginalCostsFailure: (state, action) => {
      const { requestId, error } = action.payload;
      if (state.cammesa.marginalCosts.activeRequestId !== requestId) return;

      state.cammesa.marginalCosts.isFetching = false;
      state.cammesa.marginalCosts.error = error;
      state.cammesa.marginalCosts.activeRequestId = null;
    },
  },
});

export const {
  enreUfsStart,
  enreUfsSuccess,
  enreUfsFailure,
  weatherHourlyStart,
  weatherHourlySuccess,
  weatherHourlyFailure,
  dollarQuotesStart,
  dollarQuotesSuccess,
  dollarQuotesFailure,
  cammesaCurrentDemandStart,
  cammesaCurrentDemandSuccess,
  cammesaCurrentDemandFailure,
  cammesaOperationsStart,
  cammesaOperationsSuccess,
  cammesaOperationsFailure,
  cammesaRegionsStart,
  cammesaRegionsSuccess,
  cammesaRegionsFailure,
  cammesaMarginalCostsStart,
  cammesaMarginalCostsSuccess,
  cammesaMarginalCostsFailure,
  cammesaGenerationMatrixStart,
  cammesaGenerationMatrixSuccess,
  cammesaGenerationMatrixFailure,
  cammesaHistoricalRecordsStart,
  cammesaHistoricalRecordsSuccess,
  cammesaHistoricalRecordsFailure,
  cammesaPowerFlowsStart,
  cammesaPowerFlowsSuccess,
  cammesaPowerFlowsFailure,
} = powerSystemMonitoringSlice.actions;

export default powerSystemMonitoringSlice.reducer;
